export const MANUFACTURING_ORDER_EN = {
  title: 'Manufacturing Order Management',
  pageName: 'Manufacturing Order',
  all: 'All',
  created: 'Created',
  canceled: 'Canceled',
  waiting_finance: 'Waiting Finance',
  waiting_inbound: 'Waiting Inbound',
  inbounded: 'Inbounded',
  full_paid: 'Full Paid',
  number: 'MO Number',
  produceQuantity: 'Produce Quantity',
  producePrice: 'Produce Price',
  producePriceVAT: 'Produce Price (VAT)',
  totalProducePrice: 'Total Produce Price',
  totalProducePriceVAT: 'Total Produce Price (VAT)',
  createMOrder: 'Create Manufacturing Order',
  paymentTermDays: 'Payment Term Days',
  deposit: 'Deposit',
  totalAmountVAT: 'Total Amount (VAT)',
  totalAmount: 'Total Amount',
}
